<ion-header class="header public-header">
    <ion-row class="ion-align-items-center">
        <ion-col class="ion-text-left">
            <a href="https://www.mapfreglobalrisks.com/" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/images/LogoMAPFREGR_new.svg" alt="" class="logo-header">
            </a>
        </ion-col>
        <ion-col class="ion-text-right">
            <ion-item popoverWidth lines="none" class="ion-no-padding lenguage-selector">
                <span class="icon icon-SMALL-ARROW-DOWN"></span>
                <ion-select class="ml-0" [value]="langSelected" interface="popover" slot="end" mode='md' (ionChange)="changeLanguage($event)">
                     @if('header.es' | translate) {
                    <ion-select-option value="es">{{ 'header.es' | translate }}</ion-select-option>
                    <ion-select-option value="en">{{ 'header.en' | translate }}</ion-select-option>
                    <ion-select-option value="pt">{{ 'header.pt' | translate }}</ion-select-option>
                }
                </ion-select>
            </ion-item>
        </ion-col>
    </ion-row>
</ion-header>
